import { getUserBucket } from 'lib/math/bucketHash'
import { Optional } from 'lib'
import { EmbedQueryParameters } from 'components/vendor/MultiProductWidget/types'
import { EMBED_COMPANY_UUIDS, EMBED_PRODUCTS } from 'parameters/embeds'
import { ga4Client } from 'services/AnalyticsLite/GA4/utils/client'

enum COHORTS {
	CONTROL,
	VARIANT
}

const CREDIT_EXP_TAG_KEY = 'tag.exp6_embed_credit'
const CREDIT_EXP_TAG_VALUES: Record<COHORTS, string> = {
	[COHORTS.VARIANT]: 'no_default',
	[COHORTS.CONTROL]: 'default_good'
}

const getUserBucketBinomial = (): Optional<COHORTS> => {
	const percentile = getUserBucket()
	if (percentile === undefined) return undefined
	return percentile < 0.5 ? COHORTS.CONTROL : COHORTS.VARIANT
}

export const applyFionaCreditExperiment = (params: EmbedQueryParameters) => {
	// console.debug('Applying Experiment', JSON.stringify(params))
	// Only apply to fiona organic loans
	if (params.company_uuid != EMBED_COMPANY_UUIDS[EMBED_PRODUCTS.LOAN]) return params
	//Only apply to users who want the application
	if (params.step != 'application') return params
	// See if we can ID them
	const bucket = getUserBucketBinomial()
	//Sorry suckers
	if (bucket === undefined) return params

	console.debug(`User is qualified and is part of the ${CREDIT_EXP_TAG_VALUES[bucket]} bucket`)
	//Do the test logic
	switch (bucket) {
		case COHORTS.CONTROL:
			params['app.providedCreditRating'] = 'good'
			break
		case COHORTS.VARIANT:
			delete params['app.providedCreditRating']
			break
	}
	//Tag the user for looker
	params[CREDIT_EXP_TAG_KEY] = CREDIT_EXP_TAG_VALUES[bucket]
	ga4Client.eventsClient.trackEvent('experiment_activation', {
		experiment: CREDIT_EXP_TAG_KEY,
		event_label: CREDIT_EXP_TAG_VALUES[bucket]
	})
	console.debug('Returning modified props', JSON.stringify(params))
	return params
}
